<template>
  <FormPage
    title="Новая машина"
    description="Создайте автомобиль-исполнителя. Поля «Номер» и «VIN» обязательны."
  >
    <template #controls>
    </template>
    <CarForm :no-trailer="true" @sendForm="onSubmit" @closeForm="onCancel" />
  </FormPage>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { createToaster } from '@meforma/vue-toaster'
import CarForm from '@/components/forms/CarForm.vue'

const toaster = createToaster()

export default {
  name: 'CarCreatePage',
  components: { CarForm },
  setup() {
    const router = useRouter()
    const store = useStore()

    const onSubmit = async ({ model, form }) => {
      const created = await store.dispatch('apiStorage/addItem', { model, form })
      if (!created) return
      toaster.success('Машина добавлена')
      const id = created.id || created.car?.id
      if (id != null) {
        router.push({ name: 'CarDetail', params: { id: String(id) } })
      } else {
        router.push({ name: 'Car' })
      }
    }

    const onCancel = () => {
      router.push({ name: 'Car' })
    }

    return { onSubmit, onCancel }
  },
}
</script>
